import { DuplicateValueCheckConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getDuplicateCheckTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as DuplicateValueCheckConfig;

	const hasUniqueFieldsSelectedSteps = (): AdvancedTourStep[] => {
		if (config.uniqueFields.length === 0) return [];

		return [
			{
				id: 'unique-field',
				selector: '[data-tour="unique-field"]',
				content: 'This is a selected unique field with additional properties',
			},
			{
				id: 'unique-field-case',
				selector: '[data-tour="unique-field-case"]',
				content:
					'Sets whether the selected field would be case-sensitive when checking unique values.',
			},
			{
				id: 'unique-field-delete',
				selector: '[data-tour="unique-field-delete"]',
				content: 'Remove the unique field from the key value.',
			},
		];
	};

	return [
		{
			id: 'uniqueness-check',
			selector: '[data-tour="uniqueness-check"]',
			content:
				'This is used to set the duration of how long the data needs to be kept unique and prevent duplicate data.',
		},
		{
			id: 'unique-constraint',
			selector: '[data-tour="unique-constraint"]',
			content:
				'Set the unique constraint, this determines whether the value is unique based on the client/tenant/integration-template/project.',
		},
		{
			id: 'unique-fields',
			selector: '[data-tour="unique-fields"]',
			content:
				'Set the "Fields" that will create the uniqueness key, the fields order determine the value of the key.',
		},
		...hasUniqueFieldsSelectedSteps(),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
